import { HttpInterceptorFn } from '@angular/common/http';

// TECH LEAD DECISION (2026-07-03): Bearer-token attachment is disabled here on purpose,
// pending the finalized authentication/authorization redesign (see the Authorization
// Architecture plan — Keycloak is currently embedding hundreds of per-field roles into the
// access token, which exceeds header-size limits on both Apache and nginx). Re-enable by
// restoring the block below once Keycloak stops embedding field-level roles and/or the
// coarse-role-only token is confirmed to fit within infra limits.
//
// import { inject } from '@angular/core';
// import { AuthService } from '../services/auth.service';
//
// export const authInterceptor: HttpInterceptorFn = (req, next) => {
//   const token = inject(AuthService).getToken();
//   if (!token) return next(req);
//   return next(req.clone({ setHeaders: { Authorization: `Bearer ${token}` } }));
// };

export const authInterceptor: HttpInterceptorFn = (req, next) => {
  return next(req);
};
